<template lang="html">
  <component :is="tag" class="text__small" :class="{ bold: bold }">
    <!-- @slot Безымянный слот. Используется для вставки текста-->
    <slot/>
  </component>
</template>

<script>
export default {
  name: 'bimTextSmall',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.text__small {
  font-size: 9px;
  font-weight: normal;
  line-height: 1.56;
  letter-spacing: 0.18px;
}

.text__small.bold {
  font-weight: bold;
}
</style>
